module.exports = __webpack_public_path__ + "img/headshot.1cbb4a98.png";